import { createGetApiHook } from "../apiHooks";
import { APIResponseType } from "../../../types/generics/APIResponse.type";

const getDescription = ({ businessId }: { businessId: number }) =>
  `/business/${businessId}/description`;

export const useGetDescription = createGetApiHook<
  APIResponseType<any>,
  { businessId: number }
>(getDescription);
